import PageNotFound from "../../../pages/pageNotFound";
import Login from "../../../pages/login";
import RequiresVerification from "./requiresVerification";
import Profile from "../../../pages/profile";
import { Navigate, Outlet, createBrowserRouter } from "react-router-dom";
import SnackbarProvider from "../../../providers/SnackbarProvider/SnackbarProvider";
import Layout from "../../../Components/Layout";
import { routes } from "./staticContents";
import Exams from "../../../pages/exams";
import Home from "../../../pages/home";
import { initialModule } from ".";
import Settings from "../../../pages/settings";
import GlobalLoaderProvider from "../../../providers/GlobalLoaderProvider";
import NotVerfied from "./NotVerfied";
import OrderManagement from "../../../pages/orderManagement";
import UsersPermissions from "../../../pages/usersPermissions";
import MockTest from "../../../pages/mockTest";
import EditScreen from "../../../pages/contentFeedback/EditScreen";
import InternalUsers from "../../../pages/usersPermissions/internalUsers";
import Permissions from "../../../pages/usersPermissions/permissions";
import { ProofReading } from "../../../pages/proofReading/ProofReading";
import { QuestionRawContainer } from "../../../Components/ProofReadingComponents/QuestionRawContainer";
import Pendingapproval from "../../../pages/pendingapproval";
import ModuleAccess from "./RouteExist";
import QuestionClusterMapping from "../../../pages/QuestionClusterMapping";
import CfContainer from "../../../pages/contentFeedback/CfContainer";
import ContentMangements from "../../../pages/ContentMangements";
import MockMangementsContainer from "../../../pages/MockMangements";
const router = createBrowserRouter([
  {
    element: (
      <SnackbarProvider>
        <Layout>
          <Outlet />
        </Layout>
      </SnackbarProvider>
    ),
    // errorElement: <ErrorBoundary />,
    children: [
      { path: routes.initial, element: <Navigate to={initialModule.path} /> },
      //  public routes
      {
        element: (
          <NotVerfied>
            <Outlet />
          </NotVerfied>
        ),
        children: [
          {
            path: "/login",
            element: <Login />,
          },
        ],
      },
      // unknown sources
      {
        path: "*",
        element: <PageNotFound />,
      },
      // protected routes
      {
        element: (
          <RequiresVerification>
            <GlobalLoaderProvider>
              <ModuleAccess>
                <Outlet />
              </ModuleAccess>
            </GlobalLoaderProvider>
          </RequiresVerification>
        ),
        children: [
          {
            path: routes.profile,
            element: <Profile />,
          },
          {
            path: routes.contentManage,
            element: <ContentMangements />,
            children: [],
          },
          {
            path: routes.mockManage,
            element: <MockMangementsContainer />,
            children: [],
          },
          {
            path: routes.exams,
            element: <Exams />,
          },
          {
            path: routes.home,
            element: <Home />,
          },
          { path: routes.settings, element: <Settings /> },
          {
            path: routes.mockTest,
            element: <MockTest />,
          },
          {
            path: routes.contentFeedback,
            element: <CfContainer />,
          },
          {
            path: routes.orderManagement,
            element: <OrderManagement />,
          },
          {
            path: routes.usersPermissions,
            element: <UsersPermissions />,
          },
          { path: routes.pendingapproval, element: <Pendingapproval /> },
          {
            path: routes.internalUsers,
            element: <InternalUsers />,
          },
          {
            path: routes.permissions,
            element: <Permissions />,
          },
          {
            path: routes.proofReading,
            element: <ProofReading />,
            children: [
              {
                path: "preview/:questionRowNumber/editor",
                element: (
                  <QuestionRawContainer />
                  // <>
                  //   <QuestionRawContainer />
                  //   {/* <QuestionPreview />, */}
                  // </>
                ),
                // children: [{ path: "raw-data", element: <QuestionRawContainer /> }],
              },
            ],
          },
          {
            path: routes.questionClusteringReview,
            element: <QuestionClusterMapping />,
            children: [],
          },
          {
            path: `/contentFeedback/editScreen/:id/:contentid`,
            element: <EditScreen />,
          },
        ],
      },
    ],
  },
]);

export default router;
